import React from 'react'

import genId from '../utils/gen_id'
import AddIcon from './add-icon'
import CloseIcon from './close-icon'
import Button from './button'
import {useSave} from './object-store'
import useSpinning from './use-spinning'
import WrappingButtons from './wrapping-buttons'
import {decreaseWeight} from './wrktset-editor'
import {increaseWeight} from './wrktset-editor'
import Modal from './modal'
import {useObjectStore} from './object-store'



export default function AddSetModal({onClose, onAdd, wrktsets, initialDay}) {
    const [day, setDay] = React.useState(initialDay || new Date().toISOString().split('T')[0])
    const [exercise, setExercise] = React.useState('')
    const [count, setCount] = React.useState('')
    const [weight, setWeight] = React.useState('')
    const innerRef = React.useRef()
    const save = useSave()
    const {state} = useObjectStore()

    const exercises = React.useMemo(() => {
        const exercises = {}
        wrktsets.ids.forEach(id => {
            if (state[id].exercise) {
                exercises[state[id].exercise] = true
            }
        })
        return exercises
    }, [wrktsets])
    const matchingExercies = React.useMemo(() => {
        return Object.keys(exercises)
            .filter(e => e.toLowerCase().indexOf(exercise.toLowerCase()) != -1)
    }, [exercises, exercise])

    const {
        increaseSpinningCounter,
        decreaseSpinningCounter,
        spinning,
    } = useSpinning()

    function addSet() {
        increaseSpinningCounter()
        save('wrktset', {
            id: genId(),
            day,
            exercise,
            weight,
            count,
        })
            .then(() => {
                if (onAdd) {
                    onAdd()
                    onClose()
                }
            })
            .then(() => {
                decreaseSpinningCounter()
            })
            .catch(() => {
                decreaseSpinningCounter()
            })
    }

    return <Modal stretch onClose={onClose} wide>
        <div className="spacer spacer--end">
            <Button onClick={onClose} background={null}>
                <CloseIcon />
            </Button>
        </div>
        <input aria-label="Date" type="date"
            value={day}
            onChange={e => {
                setDay(e.target.value)
            }}
        />
        <input
            type="text"
            placeholder="exercise"
            value={exercise}
            onChange={e => setExercise(e.target.value)}
        />
        <div className="spacer spacer--wrap spacer--gap2">
            {matchingExercies.map(e => {
                return <Button
                    onClick={() => setExercise(e)}
                >
                    {e}
                </Button>
            })}
        </div>
        <div className="spacer spacer--stretch">
            <WrappingButtons
                onTopClick={() => increaseWeight(setWeight)}
                onBottomClick={() => decreaseWeight(setWeight)}
                active
                grow
            >
                <input
                    className="short-input in-m"
                    placeholder="weight"
                    value={weight}
                    onChange={e => setWeight(e.target.value)}
                />
            </WrappingButtons>
            <WrappingButtons
                onTopClick={() => setCount(p => (p || 0) + 1)}
                onBottomClick={() => setCount(p => (p || 0) - 1)}
                active
                grow
            >
                <input
                    className="short-input in-r"
                    placeholder="count"
                    value={count}
                    onChange={e => setCount(e.target.value)}
                />
            </WrappingButtons>
        </div>
        <Button
            onClick={addSet}
            disabled={spinning}
        >
            <AddIcon color="white" /> Add
        </Button>
    </Modal>
}
